import React, {useState} from 'react';
import {Select, Input, Form, DatePicker, Button} from "antd";
import {DIALOG_KEY} from "../../shared/utils/enum";
import toast from "react-hot-toast";
import duration from 'dayjs/plugin/duration';
import dayjs from "dayjs";
import {CancelButton, CopyButton, DeleteButton, SaveButton} from "../../shared/components/buttons/CustomButtons";
import DateStepper from "../../shared/components/date/DateStepper";
import CustomDateTimePicker from "../../shared/components/date/CustomDateTimePicker";
import {useMergeEventMasterTableData} from "../logs/useTableData";

dayjs.extend(duration);

const GameManagerEditModal = ({record, handleClose, dialogRef, handleSetDialog, modalOptions}) => {
    const [row, setRow] = useState(new modalOptions.entity(record));
    const {data: mergeEventMasterTable, isLoading: isLoadingMergeEventMasterTable, error: mergeEventMasterTableError} = useMergeEventMasterTableData();

    const handleSetRows = (key, value) => {
        console.log(`handleSetRows: ${key} = ${value}`);
        setRow((prevState) => {
            const newState = {...prevState};
            newState[key] = value;
            return new modalOptions.entity(newState);
        });
    }

    const handleSave = async (e) => {
        e.preventDefault();

        if (row.isInvalidate()) return;

        await modalOptions.save(row.toJson());
        handleSetDialog([{key: DIALOG_KEY.OPEN, value: false}, {key: DIALOG_KEY.CONFIRM_TEXT, value: ""}]);
        if (handleClose) handleClose();
    }

    const handleCopy = async (e) => {
        e.preventDefault();

        if (row.isInvalidate()) return;
        row.seq = 0; // 복사 시에는 seq 초기화
        row.onOff = 0; // 복사 시에는 off 상태로 저장
        const newRow = new modalOptions.entity(row.toJson());
        await modalOptions.save(newRow.toJson());
        handleSetDialog([{key: DIALOG_KEY.OPEN, value: false}, {key: DIALOG_KEY.CONFIRM_TEXT, value: ""}]);
        if (handleClose) handleClose();
    }

    const handleDelete = async (e) => {
        e.preventDefault();
        const currentDialog = dialogRef.current;  // ref에서 최신 상태 가져오기
        if (currentDialog.confirmText === 'DELETE') {
            await modalOptions.delete(row.seq);

            handleSetDialog([{key: DIALOG_KEY.OPEN, value: false}, {key: DIALOG_KEY.CONFIRM_TEXT, value: ""}]);
            if (handleClose) handleClose();
        } else {
            toast.error("잘못된 확인 문자입니다. DELETE 를 입력하세요.");
            handleSetDialog([{key: DIALOG_KEY.CONFIRM_TEXT, value: ''}]);
        }
    }

    const handleDateChange = (key, value) => {
        const unixTime = dayjs(value).hour(9).startOf('minute').unix();
        handleSetRows(key, unixTime);
    }

    return (
        <div>
            <div style={{ marginTop: 26 }}>
                <Form layout="inline">
                    <Form.Item label="이름" style={{marginBottom: 8, width: '75%'}}>
                        <Input
                            name={"name"}
                            value={row.name}
                            onChange={(e) => handleSetRows('name', e.target.value)}
                            size="small"
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                    <Form.Item label="OnOff" style={{marginBottom: 8, marginLeft: 8, width: '15%'}}>
                        <Select
                            value={row.onOff}
                            onChange={(value) => handleSetRows('onOff', value)}
                            size="small"
                        >
                            <Select.Option value={1}>On</Select.Option>
                            <Select.Option value={0}>Off</Select.Option>
                        </Select>
                    </Form.Item>
                    {
                        modalOptions.isPopup && (
                            <div style={{display: 'flex', alignItems: 'center', gap: 8, marginTop: 8, width: '100%'}}>
                                <Form.Item label="팝업 인덱스" style={{marginBottom: 8, width: '15%'}}>
                                    {row.index}
                                </Form.Item>
                                <Form.Item label="오픈 레벨" style={{marginBottom: 8, marginLeft: 8, width: '15%'}}>
                                    {row.openLevel}
                                </Form.Item>
                                <Form.Item label="메모" style={{marginBottom: 8, marginLeft: 8, width:'55%'}}>
                                    <Input
                                        name={"memo"}
                                        value={row.memo}
                                        onChange={(e) => handleSetRows('memo', e.target.value)}
                                        size="small"
                                        style={{ width: '100%' }}
                                    />
                                </Form.Item>
                            </div>
                        )
                    }
                    {modalOptions.isMergeEvent && (
                        <>
                            <Form.Item label="머지 이벤트 타입" style={{marginBottom: 8, width: '15%'}}>
                                {row.mergeEventType}
                            </Form.Item>
                            <Form.Item label="최소 적용 버전" style={{marginBottom: 8, width: '25%'}}>
                                {mergeEventMasterTable.find(e => e.index === row.index)?.openVersion}
                            </Form.Item>
                        </>
                    )}
                    {modalOptions.isSeasonTheme && (
                        <Form.Item label="리소스 번호" style={{marginBottom: 8, width: '15%'}}>
                            {row.resourceIdx}
                        </Form.Item>
                    )}
                </Form>
            </div>
            {modalOptions.isSeasonTheme ? (
                <div style={{display: 'flex', alignItems: 'center', gap: 8, marginTop: 8}}>
                    <div>
                        <DatePicker
                            format="YYYY-MM-DD"
                            value={row.begin ? dayjs.unix(row.begin) : null}
                            onChange={value => handleDateChange('begin', value)}
                            style={{marginRight: 8, width: 160}}
                            placeholder="시작일시"
                        />
                        <DateStepper setRows={setRow} entity={modalOptions.entity} isEnd={false}/>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', gap: 4, marginLeft: 16, marginBottom: 14}}>
                        <div>
                            <Input
                                name={"반복 주기"}
                                value={row.rotationCount}
                                onChange={(e) => handleSetRows('rotationCount', e.target.value)}
                                style={{ width: 100 }}
                            />
                        </div>
                        <div style={{display: 'flex', gap: 8}}>
                            <Button
                                onClick={() => {
                                    handleSetRows('rotationCount', Number(row.rotationCount) + 1);
                                }}
                            >
                                {'반복 주기 + 1'}
                            </Button>
                            <Button
                                onClick={() => {
                                    const value = Number(row.rotationCount) - 1;
                                    handleSetRows('rotationCount', value < 0 ? 0 : value);
                                }}
                            >
                                {'반복 주기 - 1'}
                            </Button>
                        </div>
                    </div>
                    종료시간:&nbsp;
                    {dayjs.unix(row.begin).add(7 * row.rotationCount, 'day').subtract(1, 'second').format('YYYY-MM-DD HH:mm:ss')}
                </div>
            ) : (
                <div>
                    <CustomDateTimePicker rows={row} handleSetRows={handleSetRows} hasAdd={false}/>
                    <DateStepper setRows={setRow} entity={modalOptions.entity}/>
                </div>
            )}
            <div className={"event-edit-buttons"}>
                <CopyButton onClick={handleCopy} handleSetDialog={handleSetDialog}/>
                <SaveButton onClick={handleSave} handleSetDialog={handleSetDialog}/>
                <CancelButton onClick={handleClose}/>
                <DeleteButton onClick={handleDelete} handleSetDialog={handleSetDialog} display={false}/>
            </div>
        </div>
    );
}

export default GameManagerEditModal;
